/**
 * TYPING INDICATOR COMPONENT
 * Shows when AI is processing
 */

import React from 'react';
import { motion } from 'framer-motion';
import { Brain } from 'lucide-react';

export function TypingIndicator() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="flex items-start space-x-3"
    >
      <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
        <Brain className="w-4 h-4 text-white" />
      </div>
      
      <div className="bg-white/10 border border-white/20 rounded-lg p-4">
        <div className="flex items-center space-x-2">
          <span className="text-slate-300 text-sm">AI is thinking</span>
          <div className="typing-indicator flex space-x-1">
            <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
            <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
            <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
          </div>
        </div>
      </div>
    </motion.div>
  );
}